import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Step, Stepper } from "../../../../../../shared/components/ui/stepper/Stepper";
import { openInNewTab } from "../../../../../../shared/utils/utils";
import Popup from "../../../../../../shared/components/ui/popup/Popup";
import HeaderPopup from "../../../../../../shared/components/ui/popup/headerPopup/HeaderPopup";
import PrimaryBtn from "../../../../../../shared/components/ui/buttons/PrimaryBtn";
import CreateCourseResponse from "../createCourseResponse/CreateCourseResponse";
import UserStudyGroups from "../userStudyGroups/UserStudyGroups";
import SetNewCourseName from "../setNewCourseName/SetNewCourseName";
import downloadIcon from "../../../../../../assests/icons/download.svg";
import FetchCreateCourse from "../fetchCreateCourse/FetchCreateCourse";
import classes from "./ClassroomWizardPopup.module.css";

const ClassroomWizardPopup = ({ studyGroup, onClose, studyGroupId }) => {

    const providerKey = studyGroup?.key;
    const entityField = studyGroup?.entityField;
    const showErrorPdf = studyGroup?.showErrorPdf;

    const { texts } = useSelector((state) => state.translate);
    const { general } = useSelector(state => state.uiData);
    const [courseData, setCourseData] = useState();

    const handleEnd = () => onClose && onClose();

    const openPdf = () => {
        return openInNewTab(general?.downloadPageInCreateStudyGroup)
    }

    const renderDownloadButton = () => (
        showErrorPdf ?
            <PrimaryBtn dropClass={classes.BtnDownload} onClick={openPdf}>
                <img src={downloadIcon} alt="" />
                {texts.solutionInCreateStudyGroup}
            </PrimaryBtn>
            : null
    );

    return (
        <Popup close={handleEnd} title={texts.openStudyGroup} dropClass={classes.BackdropPopupClass} dropClassClose={classes.DropClassClose} >
            <HeaderPopup className={classes.HeaderPopup}>
                <p className={classes.Title}>{texts.openStudyGroup}</p>
            </HeaderPopup>
            <Stepper end={handleEnd} onCancel={handleEnd}>
                <Step title={texts.chooseStudyGroup} next disable={!courseData} footerChildren={renderDownloadButton()}>
                    <UserStudyGroups providerKey={providerKey} entityField={entityField} studyGroupId={studyGroupId} courseData={courseData} setCourseData={setCourseData} />
                </Step>

                <Step title={texts.createName} next nextText={texts.create} disable={!courseData?.newName} footerChildren={renderDownloadButton()}>
                    <SetNewCourseName courseData={courseData} setCourseData={setCourseData} />
                </Step>

                <Step hideFooter>
                    <FetchCreateCourse providerKey={providerKey} entityField={entityField} courseData={courseData} setCourseData={setCourseData} />
                </Step>

                <Step hideFooter cancelText={texts.closeAndBackToDashboard}>
                    <CreateCourseResponse
                        status={courseData?.response?.status}
                        body={courseData?.response?.body}
                        successText={texts.successText}
                        errorText={texts.failedCreateCourse}
                        showErrorPdf={showErrorPdf}
                    />
                </Step>
            </Stepper >
        </Popup >
    );
};

export default ClassroomWizardPopup;
